import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { InputTextModule } from 'primeng/inputtext';
import { SidebarModule } from 'primeng/sidebar';
import { BadgeModule } from 'primeng/badge';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TooltipModule } from 'primeng/tooltip';
import { RippleModule } from 'primeng/ripple';
import { MegaMenuModule } from 'primeng/megamenu';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { StyleClassModule } from 'primeng/styleclass';

import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { MenuComponent } from './components/menu/menu.component';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { MenuProfileComponent } from './components/menu-profile/menu-profile.component';
import { RightMenuComponent } from './components/right-menu/right-menu.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ConfigModule } from './config/config.module';
import { BaseLayoutComponent } from './components/base-layout/base-layout.component';
import { AuthenticationService } from '../authentication/services/authentication.service';
import { AuthenticationGuard } from '../shared/guards/authentication-guard';
import { CookieService } from 'ngx-cookie-service';
import { InterceptorService } from '../shared/interceptors/interceptor.service';
import { ProgressSpinnerComponent } from '../shared/components/progress-spinner/progress-spinner.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SpinnerService } from '../shared/services/spinner.service';
import { SharedModule } from '../shared/shared.module'; 
import { JobTimesheetComponent } from './components/job-timesheet/job-timesheet.component';
import { JobExpenseComponent } from './components/job-expense/job-expense.component';
@NgModule({
  declarations: [
    BaseLayoutComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    MenuComponent,
    MenuItemComponent,
    MenuProfileComponent,
    RightMenuComponent,
    BreadcrumbComponent,
    ProgressSpinnerComponent,
    JobTimesheetComponent,
    JobExpenseComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    StyleClassModule,
    InputTextModule,
    SidebarModule,
    BadgeModule,
    RadioButtonModule,
    InputSwitchModule,
    TooltipModule,
    MegaMenuModule,
    RippleModule,
    RouterModule,
    ButtonModule,
    MenuModule,
    ConfigModule,
    ProgressSpinnerModule,
    SharedModule
  ],
  providers:[
    CookieService,

    AuthenticationService, 
    AuthenticationGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
    SpinnerService
  ],
})
export class LayoutModule { }
